import { useLoaderData, redirect } from "react-router-dom";
import { motion } from "framer-motion";
import { HiArrowPath, HiExclamationTriangle } from "react-icons/hi2";

import Transaction from "./Transaction";
import adminUi from "../UI/AdminUi.module.css";
import { getTransactions } from "../../api/api";
import { getAuthToken } from "../../util/authToken";

const listParent = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: { staggerChildren: 0.06, delayChildren: 0.03 },
  },
};

const listItem = {
  hidden: { opacity: 0, y: 16 },
  show: {
    opacity: 1,
    y: 0,
    transition: { type: "spring", stiffness: 400, damping: 30 },
  },
};

function sortTransactionsNewestFirst(list) {
  return [...list].sort((a, b) => {
    const ta = new Date(a.createdAt || 0).getTime();
    const tb = new Date(b.createdAt || 0).getTime();
    if (tb !== ta) return tb - ta;
    return String(b._id).localeCompare(String(a._id));
  });
}

const AllTransactions = () => {
  const res = useLoaderData();
  const transactions = sortTransactionsNewestFirst(
    res?.data?.transactions ?? []
  );

  return (
    <div className={adminUi.page}>
      <h1 className={adminUi.pageTitle}>
        <HiArrowPath className={adminUi.pageTitleIcon} aria-hidden />
        Transactions
      </h1>
      <p className={adminUi.pageLead}>
        Audit transfers, reverse entries when appropriate, or remove mistaken
        records.
      </p>
      {res.status !== "success" && res.message && (
        <p className={adminUi.loadError} role="alert">
          <HiExclamationTriangle
            className={adminUi.loadErrorIcon}
            aria-hidden
          />{" "}
          {res.message}
        </p>
      )}
      <motion.section
        className={adminUi.gridCards}
        variants={listParent}
        initial="hidden"
        animate="show"
      >
        {transactions.map((el) => (
          <motion.div key={el._id} variants={listItem}>
            <Transaction
              id={el._id}
              type={el.kind}
              destination={el.bankName}
              amount={el.amount}
              sender={el.sender}
              receipient={el.receipient}
              date={el.createdAt}
              reversed={el.reversed}
            />
          </motion.div>
        ))}
      </motion.section>
    </div>
  );
};

export default AllTransactions;

export const loader = async () => {
  const jwt = getAuthToken();
  if (!jwt) {
    throw redirect("/login");
  }
  return getTransactions(jwt);
};
